import React, { useState, useEffect } from "react"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

import "./footer-consulting.scss"
import { BLOCKS } from "@contentful/rich-text-types"

const FooterConsulting = props => {
  const { mobile, params, image } = props
  const options = {
    renderNode: {
      [BLOCKS.EMBEDDED_ASSET]: (node, next) =>
        <span className="f-cicle-container">
          <img
            src={
              node.data.target.fields.file[process.env.LOCALE] ?
                node.data.target.fields.file[process.env.LOCALE].url :
                node.data.target.fields.file["es-CO"].url
            }
            alt={
              node.data.target.fields.description[process.env.LOCALE] ?
                node.data.target.fields.description[process.env.LOCALE] :
                node.data.target.fields.description["es-CO"]
            } />
        </span>,
    },
  }

  return (
    <div className="f-footer-consulting">
      <div className="f-footer-consulting-wrapper">
        { !mobile &&<img
          alt={image.description}
          src={image.file.url}
          className="f-footer-consulting-img"
        />}
        <div className={`f-footer-consulting-texts ${mobile ? 'mobile' : ''}
         ${process.env.LOCALE === 'es-PE' ? 'text-white' : ''}`}>
           {documentToReactComponents(params.json, options)}
        </div>
      </div>
    </div>
  )
}

export default FooterConsulting
